import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlideWideAdd"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 8.5V12M12 12V15.5M12 12H8.5M12 12L15.5 12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlideWideAdd;
